import React from 'react';
import Linkify from 'linkify-react';
import './ContentPreviewer.scss';

interface Props {
  children: React.ReactNode;
}

export const ContentLinkify = ({ children }: Props) => {
  return (
    <Linkify options={{ target: '_blank', rel: 'noreferrer' }}>
      <div className='content-inner'>{children}</div>
    </Linkify>
  );
};
